import layoutSlice, { actions } from "./reducer";
import * as thunkActions from "./actions";
export const layoutActions = { ...actions, ...thunkActions };
export * as LayoutTypes from './types';
export default layoutSlice;